import { useQuery } from '@tanstack/react-query';
import ErrorIndicator from 'components/ErrorIndicator';
import Spinner from 'components/Spinner';
import HTTPClient from 'services/HTTPClient';
import Article from 'components/Article'
import { useState } from 'react';
import { Select } from 'antd';

type Props = {}

export const useArticles = (filterByPending) => {

    return useQuery(['articles', filterByPending], async () => {
        let pendingApprovalURL = "/brains/docs?ordering=id&vocabulary_generated=true"
        if (filterByPending) {
            pendingApprovalURL += "&is_approved=false"
        }
        const articles = await HTTPClient.get().getJSONResultWithoutAuth(pendingApprovalURL)
        const totalArticlesURL = "/brains/docs/count"
        const totalArticlesCount = await HTTPClient.get().getJSONResultWithoutAuth(totalArticlesURL)
        const totalVocabularyGeneratedURL = "/brains/docs/count?vocabulary_generated=true"
        const totalVocabularyGenerated = await HTTPClient.get().getJSONResultWithoutAuth(totalVocabularyGeneratedURL)

        const totalVocabularyGeneratedAndApprovedURL = "/brains/docs/count?vocabulary_generated=true&is_approved=true"
        const totalVocabularyGeneratedAndApproved = await HTTPClient.get().getJSONResultWithoutAuth(totalVocabularyGeneratedAndApprovedURL)
        return { articles, totalArticlesCount, totalVocabularyGenerated, totalVocabularyGeneratedAndApproved }
    });
};

export default function CurateMetadataPage({ }: Props) {
    const [filterByPending, setFilterByPending] = useState(true)
    const { data, isFetching, error } = useArticles(filterByPending);
    let { articles = [], totalArticlesCount = 0, totalVocabularyGenerated = 0, totalVocabularyGeneratedAndApproved = 0 } = data || {}

    if (error || isFetching) {
        return <div className="column mx-4" style={{ overflow: "auto" }}>
            {isFetching ? <div className="center">
                <Spinner className='mt-6' />
            </div> : null}
            {error ? <ErrorIndicator error={error} /> : null}
        </div>
    }

    const pendingCount = articles.filter(a => a.is_approved === false).length

    return (
        <div className='mx-0 px-5 py-5' style={{ height: "100vh", overflow: "auto" }}>
            <div className='between mb-2'>
                <div>
                    <h4 className='is-size-4'>
                        There are <strong>{pendingCount}</strong> articles pending review
                    </h4>
                    <small>
                        {totalVocabularyGeneratedAndApproved} / {totalVocabularyGenerated} articles have been approved (total = {totalArticlesCount})
                    </small>
                </div>
                <div>
                    <Select
                        className='mr-2'
                        style={{ width: 120 }}
                        defaultValue={filterByPending ? "Pending" : "All"}
                        onChange={(value) => {
                            setFilterByPending(value === "Pending")
                        }}
                        options={[
                            {
                                label: "Pending",
                                value: "Pending",
                            },
                            {
                                label: "All",
                                value: "All",
                            }
                        ]}
                    />
                </div>
            </div>
            <div>
                {articles.map((article: any) => {
                    return <Article article={article} />
                })}
            </div>
        </div>
    )
}